module.exports = __webpack_public_path__ + "static/media/logo-azapfy-web-branco.056709b2.png";